import {createAction} from 'util/redux';
import {EvoMenuTO} from 'generated/JavaTO';
import {MenuStyle} from 'appmodule/home/type/MenuStyle';

const NAMESPACE = 'MENU/'
export const refreshMenuAction = createAction<{ force: boolean }>(NAMESPACE + 'refreshMenu')
export const resetMenuModelsAction = createAction<EvoMenuTO[]>(NAMESPACE + 'reset')
export const switchMenuStyleAction = createAction<MenuStyle>(NAMESPACE + 'switchView')
export const setActiveMenuNodeAction = createAction<number | null>(NAMESPACE + 'setActiveMenuNode')
